import {useContext} from 'react';
import {SnackBarContext} from '../context/SnackBarProviders';


export default function useModule() {
    const { isSnackBar, setSnackBar} = useContext(SnackBarContext);

    return {
        isSnackBar,
        setSnackBar
    }
}
